import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import intl from 'react-intl-universal';
import PaperWidget from '../components/dashboard/PaperWidget';
import CustomerService from '../services/CustomerService';
import { useLoaderData } from "react-router-dom";
import { Box } from '@mui/system';

export const AccountLoader = (auth) =>
	async () => {
		if(!auth || !auth.isAuthenticated() ){
			return null;
		}
		
		const [userResponse] = await Promise.all(
			    [
					CustomerService.getCustomerById(auth, auth.data.current.user.customerId), 
				]);
		return { userResponse };
	}




function AccountDetails() {
	const { userResponse } = useLoaderData();
	const user = (userResponse.items && userResponse.items.length > 0) ? userResponse.items[0] : {};


	return (
		<Container component="main" className="viewOnly" >
			<Box sx={{ mt: 3 }}>
				<Grid container spacing={2}>

					<Grid item xs={12}>
						<TextField
							autoFocus
							fullWidth
							id="pickupLocation"
							name="pickupLocation"
							label={intl.get('pickupLocation').d('Pickup location')}
							value={user.pickupLocation ? user.pickupLocation : intl.get('notAvailable').d('Not available')}
						/>
					</Grid>
					
					<Grid item xs={12}>
						<TextField
							fullWidth
							id="email"
							name="email"
							label={intl.get('emailaddress').d('Email address')}
							autoComplete="email"
							value={user.email}
						/>
					</Grid>


					<Grid item xs={12} sm={6}>
						<TextField
							id="fname"
							name="fname"
							fullWidth
							label={intl.get('firstname').d('First name')}
							autoComplete="given-name"
							value={user.fname}						
						/>
					</Grid>

					<Grid item xs={12} sm={6}>
						<TextField
							fullWidth
							id="lname"
							name="lname"
							label={intl.get('lastname').d('Last name')}
							autoComplete="family-name"
							value={user.lname}						
						/>
					</Grid>

					<Grid item xs={12} sm={6}>
						<TextField
							fullWidth
							id="permitId"
							name="permitId"
							label={intl.get('permitnumber').d('Permit number')}
							value={user.permitId}	
						/>
					</Grid>

					<Grid item xs={12} sm={6}>
						<TextField
							fullWidth
							id="permitExpiration"
							name="permitExpiration"
							label={intl.get('permitexpiration').d('Permit expiration')}
							value={user.permitExpirationFormatted}
						/>
					</Grid>
					
					<Grid item xs={12} sm={6}>
						<TextField
							fullWidth
							id="dob"
							name="dob"
							label={intl.get('dob').d('Date of birth')}
							autoComplete="bday"
							value={user.dobFormatted}						
						/>
					</Grid>
					
					<Grid item xs={12} sm={6}>
						<TextField
							fullWidth
							id="phone"
							name="phone"
							label={intl.get('mobilephone').d('Mobile phone')}
							autoComplete="tel-national"
							value={user.phoneFormatted}
						/>
					</Grid>

					<Grid item xs={12}>
						<TextField
							fullWidth
							id="address1"
							name="address1"
							label={intl.get('addressline1').d('Address line 1')}
							autoComplete="address-line1"
							value={user.address1}
						/>
					</Grid>

					<Grid item xs={12}>
						<TextField
							fullWidth
							id="address2"
							name="address2"
							label={intl.get('addressline2').d('Address line 2')}
							autoComplete="address-line2"
							value={user.address2}
						/>
					</Grid>

					<Grid item xs={12} sm={4}>
						<TextField
							fullWidth
							id="city"
							name="city"
							label={intl.get('city').d('City')}
							autoComplete="address-level2"
							value={user.city}
						/>
					</Grid>

					<Grid item xs={12} sm={4}>
						<TextField
							fullWidth
							id="state"
							name="state"
							label={intl.get('state').d('State')}
							autoComplete="address-level1"
							value={user.state}
						/>
					</Grid>

					<Grid item xs={12} sm={4}>
						<TextField
							fullWidth
							id="zipcode"
							name="zipcode"
							label={intl.get('zip').d('Zip')}
							autoComplete="postal-code"
							value={user.zipcode}
						/>
					</Grid>
				</Grid>
			</Box>
		</Container>

	);
}




export default function Account() {
	return (
		<>
			<Grid container spacing={3}>
				<PaperWidget
					title="Account"
					gridProps={{ xs: 12, md: 4, lg: 3 }}
					paperProps={{ sx: { p: 2, display: 'flex', flexDirection: 'column' } }}
				>
					<AccountDetails />
				</PaperWidget>
			</Grid>
		</>
		
	);
}